var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFatigue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/hazard/fatigue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/hazard/fatigue",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0476691,25.5467454 C50.2009218,22.5978514 54.3345875,21.9538067 57.2834815,24.1070594 C58.0192566,24.6448898 64.5688139,29.5655066 67.7282052,36.5534391 C71.0836102,43.9720221 71.0556082,51.1916948 65.3799046,54.7054555 C65.1269215,54.9362301 64.8469021,55.1457619 64.535984,55.3205326 C60.1589911,57.7962904 54.9844256,62.1781112 54.5518439,64.5109625 C53.7079234,69.0578983 57.1000205,76.1559074 58.3562455,78.2840548 C59.653025,80.4855867 58.9220778,83.3215073 56.7215115,84.6182869 C55.9828397,85.0547309 55.1746457,85.2604003 54.375142,85.2604003 C52.791584,85.2604003 51.2485806,84.4473785 50.3863139,82.9835529 C49.710405,81.8393357 43.8357911,71.5462086 45.4550757,62.8221559 C45.7186801,61.3979192 46.2970651,60.0190651 47.077257,58.7078018 C47.0367025,58.709733 46.9990447,58.7184232 46.9594558,58.7184232 C46.8310331,58.7184232 46.7045416,58.7106985 46.5741877,58.6971804 C44.7608207,58.4857174 43.46211,56.84519 43.6735729,55.0318229 L43.6735729,55.0318229 L46.7875818,28.2638991 C46.8493792,27.7405525 47.0395993,27.2674163 47.3099628,26.8531807 C47.5040452,26.4003217 47.7454413,25.960981 48.0476691,25.5467454 Z M52.3802452,37.3906005 L50.3882451,54.5017172 C52.612951,52.2277666 55.1534029,50.3400496 57.1164354,49.0336142 C57.1280225,48.2843209 57.1502309,46.6573116 57.1106419,46.8427038 C57.1241601,46.7741473 56.9841504,44.8690498 55.6844742,41.9993337 C54.9284218,40.3230796 53.6258487,38.6960703 52.3802452,37.3906005 L52.3802452,37.3906005 Z M37.9835786,15.006815 C42.2099405,15.1854481 45.4929266,18.7571438 45.3142935,22.9844713 C45.1346949,27.2108331 41.5639647,30.491888 37.3376028,30.3132549 C33.1102754,30.1346219 29.8292205,26.5638917 30.006888,22.3375299 C30.1864866,18.1111681 33.7562512,14.8301131 37.9835786,15.006815 Z",
    id: "fatigue",
    fill: "#1C7B97"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFatigue);
export default __webpack_public_path__ + "static/media/fatigue.43e23874.svg";
export { ForwardRef as ReactComponent };